/* eslint-disable no-console */
/* eslint-disable max-len */
/* eslint-disable no-param-reassign */
/* eslint-disable import/no-absolute-path */
/* eslint-disable react/no-unused-state */
/* eslint-disable react/prop-types */
import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import Stepper from '@material-ui/core/Stepper';
import Step from '@material-ui/core/Step';
import StepLabel from '@material-ui/core/StepLabel';
import Button from '@material-ui/core/Button';
import Lock from '@material-ui/icons/Lock';
import Avatar from '@material-ui/core/Avatar';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import CircularProgress from '@material-ui/core/CircularProgress';
import red from '@material-ui/core/colors/red';
import { Query } from 'react-apollo';
import {
  isEmpty,
  path,
  curry,
  allPass,
  propEq,
  isNil,
  map,
  find,
  compose,
  contains,
  pathOr,
  prop,
} from 'ramda';
import { components as commonComponents } from '@555platform/portal-components/lib/client';
import uuidv4 from 'uuid/v4';
import CopyRoleForm from './CopyRoleForm';
import { RolesContainer, GET_ROLE } from './RolesContainer';
import Permissions from './Permissions';


const ERROR_MESSAGE_TTL_MS = 5000;

const styles = theme => ({
  backButton: {
    marginRight: theme.spacing.unit,
    fontSize: '14px',
  },
  backButtonHidden: {
    display: 'none',
    marginRight: theme.spacing.unit,
    fontSize: '14px',
  },
  instructions: {
    marginTop: theme.spacing.unit,
    marginBottom: theme.spacing.unit,
  },
  button: {
    fontSize: '14px',
    color: '#FFFFFF',
  },
  card: {
    minWidth: 275,
    overflow: 'visible',
  },
  buttons: {
    marginTop: '1rem',
  },
  buttonProgress: {
    color: red[500],
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginTop: -12,
    marginLeft: -12,
  },
  error: {
    width: '100%',
    textAlign: 'center',
    color: '#b61402',
    animation: `inOut ${ERROR_MESSAGE_TTL_MS / 1000}s linear`,
  },
  '@keyframes inOut': {
    '0%': {
      height: '0em',
      opacity: '0',
    },
    '4%': {
      height: '1em',
      opacity: '1',
    },
    '96%': {
      height: '1em',
      opacity: '1',
    },
    '100%': {
      height: '0em',
      opacity: '0',
    },
  },
});

const getSteps = () => ['Provide Role name and type', 'Select Permissions'];

const dataOr = (defaultValue, dataPath, data) => (isEmpty(data)
  ? defaultValue
  : path(dataPath, data)
);

const findPermission = (resource, action) => find(allPass([propEq('action', action), propEq('resource', resource)]));
const isActionEnabled = (action, permissions) => (isNil(permissions)
  ? ({ enabled: false, ...action })
  : ({ enabled: true, ...action })
);
const mapActionStates = (permissions, template) => map((mapping) => {
  const mappedActions = map(
    action => isActionEnabled(action, findPermission(mapping.resource, action.action)(permissions)),
    mapping.actions,
  );

  return {
    ...mapping,
    actions: mappedActions,
  };
})(template);

const isDuplicateKeyError = compose(
  contains('E11000 duplicate key error collection'),
  pathOr('', ['message']),
);

class CopyRole extends Component {
  state = {
    activeStep: 0,
    displayName: '',
    team: '',
    name: '',
    permissions: '',
    creatingRole: false,
    error: null,
    roleTeam: '',
  };

  onPermissionChange = curry((handlers, roleIdentifier, resource, action, isEnabled) => {
    const { allowFn, removeFn } = handlers;
    return isEnabled
      ? allowFn({ variables: { action, resource, roleIdentifier } })
      : removeFn({ variables: { action, resource, roleIdentifier } });
  });

  selectTeams = () => {
    const { match, history } = this.props;
    const { displayName } = this.state;
    const { permissions } = this.state;
    history.push({
      pathname: history.push(`${match.url}/select`),
      state: { displayName, permissions },
    });
  }

  onTeamSelect = (selectedTeam) => {
    this.setState({
      roleTeam: selectedTeam,
      team: selectedTeam.description,
    });
  }

  onRoleSelection = (selectedRole) => {
    this.setState({
      displayName: selectedRole.displayName,
      permissions: selectedRole.permissions,
    });
  }

  handleBack = () => {
    this.setState(state => ({
      activeStep: state.activeStep - 1,
    }));
  };

  handleNext = async (handler) => {
    const {
      displayName, team, permissions,
    } = this.state;
    this.setState({ creatingRole: true });

    if (displayName === '' || team === '') {
      this.setState({
        error: new Error('Both name and team values are required'),
        creatingRole: false,
      });
      return;
    }

    const newName = uuidv4();

    const roleIdentifier = {
      name: newName,
      displayName,
      team,
    };

    try {
      await handler({ variables: { roleIdentifier, permissions } });
    } catch (err) {
      if (isDuplicateKeyError(err)) {
        this.setState({ error: new Error('Role with this name already exists') });
      } else {
        this.setState({ error: new Error('Could not create new role, try again later') });
      }

      this.setState({ creatingRole: false });
      return;
    }

    this.setState(state => ({
      activeStep: state.activeStep + 1,
      creatingRole: false,
      name: newName,
    }));
  };

  getStepContent = () => {
    const {
      activeStep, displayName, team, name, permissions, roleTeam,
    } = this.state;
    switch (activeStep) {
      case 0:
        return (
          <CopyRoleForm
            onTeamSelect={this.onTeamSelect}
            onRoleSelection={this.onRoleSelection}
            roleTeam={roleTeam}
            permissions={permissions}
          />
        );
      case 1:
        return (
          <Query
            query={GET_ROLE}
            notifyOnNetworkStatusChange
            variables={{ name, team }}
            context={{ useLocalError: true }}
          >
            {({ data, loading }) => {
              // if (error) return this.renderError();
              const role = dataOr(
                { roleIdentifier: { displayName: '', name: '', team: '' }, permissions: { permissions } },
                ['templatedRole', 'role'],
                data,
              );
              if (data.templatedRole) {
                data.templatedRole.role.permissions = permissions;
              }
              const template = dataOr([], ['templatedRole', 'template'], data);
              return (
                <RolesContainer roleID={role.roleIdentifier.name} teamID={team} permissions={permissions}>
                  {({ allow, removePermission }) => (
                    <Permissions
                      template={mapActionStates(role.permissions, template)}
                      onChange={this.onPermissionChange(
                        { allowFn: allow.mutation, removeFn: removePermission.mutation },
                        { role, team, displayName },
                        { permissions },
                      )}
                      isLoading={loading}
                      readOnly={false}
                    />
                  )}
                </RolesContainer>
              );
            }}
          </Query>
        );
      default:
        return 'Uknown stepIndex';
    }
  };

  render() {
    const { classes, history } = this.props;
    const steps = getSteps();
    const { activeStep, creatingRole, error } = this.state;

    if (error) {
      setTimeout(() => this.setState({ error: null }), ERROR_MESSAGE_TTL_MS + 50);
    }

    return (
      <RolesContainer>
        {() => (
          <commonComponents.Panel
            title="Copy Role"
            avatar={(
              <Avatar>
                <Lock />
              </Avatar>
            )}
          >
            <div>
              {error && <div className={classes.error}>{prop('message', error)}</div>}
              <Stepper activeStep={activeStep} alternativeLabel>
                {steps.map(label => (
                  <Step key={label}>
                    <StepLabel>{label}</StepLabel>
                  </Step>
                ))}
              </Stepper>
              <div>
                <Card className={classes.card}>
                  <CardContent>{this.getStepContent()}</CardContent>
                </Card>
                <div className={classes.buttons}>
                  <Button
                    onClick={activeStep === 0 ? () => history.goBack() : this.handleBack}
                    className={activeStep === 0 ? classes.backButton : classes.backButtonHidden}
                  >
                    {activeStep === 0 ? 'Back to Role List' : 'Back'}
                  </Button>
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={
                      activeStep === steps.length - 1
                        ? () => history.goBack()
                        : () => this.selectTeams()
                    }
                    className={classes.button}
                    disabled={creatingRole}
                  >
                    {activeStep === steps.length - 1 ? 'Finish' : 'Select Teams'}
                    {creatingRole && (
                      <CircularProgress size={24} className={classes.buttonProgress} />
                    )}
                  </Button>
                </div>
              </div>
            </div>
          </commonComponents.Panel>
        )}
      </RolesContainer>
    );
  }
}

CopyRole.propTypes = {
};

export default withStyles(styles)(CopyRole);
